import { ResultSet } from '@cubejs-client/core';
import { curry, defaultTo, isNil, isNotNil, lensPath, pipe, view } from 'ramda';

import { CubeQueryData, PurchaseOrder } from '~/common/types';
import { DimPurchaseOrderField } from '~/common/types/cubes/DimPuchaseOrder';

/**
 * Creates a lens view function over the first element in the array or returns an empty string
 * if either the array is empty or the value is nullish (cube might return null)
 */
const lensViewWithDefault = curry((data: CubeQueryData[], field: DimPurchaseOrderField) =>
  pipe(view(lensPath([0, field])), defaultTo(''))(data),
);

export const getPurchaseOrderHeader = (
  purchaseOrder: ResultSet<CubeQueryData> | null,
): Pick<PurchaseOrder, 'externalReference' | 'supplier' | 'totalValue'> => {
  if (isNil(purchaseOrder)) {
    return {
      externalReference: '',
      supplier: '',
      totalValue: 0,
    };
  }

  const totalValue = isNotNil(purchaseOrder.totalRow()[DimPurchaseOrderField.TOTAL_VALUE])
    ? Number(purchaseOrder.totalRow()[DimPurchaseOrderField.TOTAL_VALUE])
    : 0;
  const getValueOf = lensViewWithDefault(purchaseOrder.rawData());
  return {
    externalReference: getValueOf(DimPurchaseOrderField.PRIMARY_SOURCE_REFERENCE),
    supplier: getValueOf(DimPurchaseOrderField.SUPPLIER_ID),
    totalValue,
  };
};
